import React, { Component } from "react";
import {
  Navbar,
  NavbarToggler,
  Nav,
  Container,
  Collapse,
  NavItem,
  NavLink,
} from "reactstrap";
import pion from "../assets/img/GG210.png";
import { EMP } from "../utils/config";

// material ui imports
import Button from "@material-ui/core/Button";

/*
Navigation Component used in Navigation bar.
*/

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      modal: false,
      checkLogin: "",
      isshow: this.props.show,
    };
  }

  // toggle function to toggle the sidebar menus when user click on the navigation bar menu icon

  /* openModal function for opening the sign In and sign Up modal */

  /* closeModal function for closing the signIn and signUp modal */

  // function to set the active link css

  setActiveLink = (e) => {
    // easier for me, you can change with getElementById or getElementByClassName
    const links = document.getElementsByTagName("a");

    Array.from(links).forEach((el) => el.classList.remove("active"));
    e.target.classList.add("active");
  };

  // function to reset the active link css

  resetActiveLink = (e) => {
    const links = document.getElementsByTagName("a");

    Array.from(links).forEach((el) => el.classList.remove("active"));
  };

  render() {
    return (
      <>
        {this.state.isshow ? (
          <Navbar color="primary" dark fixed="top" expand="md" id="navigation">
            <Container id="navbar-container">
              <NavLink
                href="/#carousel"
                className="p-0"
                onClick={(e) => {
                  this.resetActiveLink(e);
                }}
              >
                <img
                  src={pion}
                  height="55"
                  style={{ margin: 0 }}
                  alt="PION global"
                  id="logo"
                />
              </NavLink>
              <NavbarToggler />
              <Collapse navbar>
                <Nav className="mr-auto nav-left" navbar>
                  <NavItem className="navs">
                    <NavLink
                      style={{ color: "green" }}
                      href="/#about"
                      // activeClassName="active"
                      onClick={(e) => {
                        this.setActiveLink(e);
                      }}
                    >
                      GrowthGamut
                    </NavLink>
                  </NavItem>
                  <NavItem className="navs">
                    <NavLink
                      style={{ color: "green" }}
                      href="/#services"
                      // activeClassName="active"
                      onClick={(e) => {
                        this.setActiveLink(e);
                      }}
                    >
                      Features
                    </NavLink>
                  </NavItem>
                  <NavItem className="navs">
                    <NavLink
                      style={{ color: "green" }}
                      href="/#integrations"
                      // activeClassName="menu-active"
                      onClick={(e) => {
                        this.setActiveLink(e);
                      }}
                    >
                      Integrations
                    </NavLink>
                  </NavItem>
                  {/* <NavItem className="navs">
                  <NavLink
                    href="/#pricing"
                    activeClassName="menu-active"
                    onClick={(e) => {
                      this.setActiveLink(e);
                    }}
                  >
                    Pricing
                  </NavLink> */}
                  {/* </NavItem> */}
                  <NavItem className="navs">
                    <NavLink
                      style={{ color: "green" }}
                      href="/#contact"
                      onClick={(e) => {
                        this.setActiveLink(e);
                      }}
                    >
                      Contact Us
                    </NavLink>
                  </NavItem>
                </Nav>
              </Collapse>
              <Nav navbar className="nav-right">
                <NavItem className="navs">
                  <NavLink
                    target="_blank"
                    style={{ color: "green" }}
                    href={EMP}
                    onClick={(e) => {
                      // this.openModal("login");
                      this.resetActiveLink(e);
                    }}
                  >
                    Emp Login
                  </NavLink>
                </NavItem>
                <NavItem className="navs">
                  <Button
                    disableRipple
                    href="/signin"
                    onClick={(e) => {
                      this.resetActiveLink(e);
                    }}
                    style={{
                      marginLeft: "2rem",
                      background: "green",
                      width: "150px",
                      color: "white",
                      fontSize: "16px",
                      textTransform: "none",
                    }}
                  >
                    Candidate Login
                  </Button>
                </NavItem>
              </Nav>
            </Container>
          </Navbar>
        ) : (
          false
        )}
      </>
    );
  }
}
export default Navigation;
